import { render, staticRenderFns } from "./user-form.vue?vue&type=template&id=1c8b32d2&scoped=true"
import script from "./user-form.vue?vue&type=script&lang=js"
export * from "./user-form.vue?vue&type=script&lang=js"
import style0 from "./user-form.vue?vue&type=style&index=0&id=1c8b32d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b32d2",
  null
  
)

export default component.exports